"use client";

import { usePathname, useRouter } from "next/navigation";
import { useEffect } from "react";


import { appConfig } from "@/configs";
import { LOCALES } from "@/i18n/routing";
import { getCookie } from "@/utils";
import { negotiateLanguage } from "@/utils/negotiate-language";

const PREFERRED_LANGUAGE_COOKIE_NAME = "preferred-language";

export function useLanguageRedirect() {
  const router = useRouter();
  const pathname = usePathname();
  const { defaultLanguage } = appConfig.settings.language;
  const languages = LOCALES;

  const determineLanguage = () => {
    const pathSegments = window.location.pathname.split("/").filter(Boolean);
    const urlLang = pathSegments[0];

    if (urlLang && languages.includes(urlLang)) {
      return urlLang;
    }

    const cookieLang = getCookie(PREFERRED_LANGUAGE_COOKIE_NAME);
    if (cookieLang && languages.includes(cookieLang)) {
      return cookieLang;
    }

    const acceptLanguage = typeof navigator !== "undefined" ? navigator.languages : [];
    const browserLang = negotiateLanguage(languages, defaultLanguage, acceptLanguage);

    if (browserLang && languages.includes(browserLang)) {
      return browserLang;
    }

    return defaultLanguage;
  };

  useEffect(() => {
    const selectedLang = determineLanguage();
    const pathSegments = pathname.split("/").filter(Boolean);

    let pathWithoutLanguage = "";
    if (pathSegments.length > 0 && languages.includes(pathSegments[0])) {
      pathWithoutLanguage = "/" + pathSegments.slice(1).join("/");
    } else {
      pathWithoutLanguage = pathname;
    }

    const queryString = typeof window !== "undefined" ? window.location.search : "";
    const targetPath = pathWithoutLanguage.startsWith("/") ? pathWithoutLanguage : `/${pathWithoutLanguage}`;

    const currentPath = window.location.pathname;
    const expectedPath = `/${selectedLang}${targetPath}`;

    if (currentPath !== expectedPath) {
      router.replace(`/${selectedLang}${targetPath}${queryString}`);
    }
  }, [router, languages, defaultLanguage, pathname]);
}
